import { onMounted, onUnmounted } from 'vue'

import { EXTERNAL_LINKS } from '@/scripts/app-configs/constants'

export default function useIframeCommunication(callback, opts = {}) {

  const options = {
    filterOrigin: true,
    ...opts,
  }

  const handleMessageEvent = (event) => {
    if (options.filterOrigin && event.origin !== EXTERNAL_LINKS.uiPortal.url) return

    if (callback) {
      callback(event)

      return
    }
  }

  const updateIframeRoute = (url, iframe) => {
    if (iframe) {
      iframe.contentWindow.postMessage({ type: 'update:url', payload: { url } }, EXTERNAL_LINKS.uiPortal.url)
    }
  }

  onMounted(() => {
    window.addEventListener('message', handleMessageEvent)
  })

  onUnmounted(() => {
    window.removeEventListener('message', handleMessageEvent)
  })

  return {
    updateIframeRoute,
  }
}
